// --- Enums ---
export enum DependencyType {
  Finance = "Finance",
  Warehouse = "Warehouse",
  Vendor = "Vendor",
  Procurement = "Procurement",
  ARTeam = "AR",
  BTPL = "BTPL",
  Category = "Category",
}
export enum DepartmentType {
  Finance = "Finance",
  Warehouse = "Inwarding",
  Vendor = "Vendor",
  Procurement = "Procurement",
  ARTeam = "AR",
  BTPL = "BTPL",
  Category = "Category",
}

export enum SummaryStatus {
  ReviewPending = "Review Pending",
  ClarificationPending = "Clarification Pending",
  BookingPending = "Booking Pending",
  Resolved = "Resolved",
  ApprovedForBooking = "Approved for Booking",
  DocsPending = "Docs Pending",
  LeadershipApprovalRequired = "Leadership Approval Required",
  RequireConfirmation = "Require Confirmation",
}

export enum DocType {
  Invoice = "Invoice",
  Payment = "Payments",
  PRRTV = "PR/ RTV",
  BrandPromo = "Brand Promo",
  Visibility = "Visibility",
  Reversal = "Reversal",
  InternalDocument = "Internal Document",
  DNCN = "DNCN",
}

export enum AttachmentType {
  POD = "POD",
  Others = "Others",
}

export enum VendorDisputeStatusEnumDR {
  NO_DISPUTE = "No Dispute",
  DISPUTE_RAISED = "Dispute Raised",
  DISPUTE_RESOLVED = "Dispute Resolved",
}
